<script>
import { mapState, mapActions } from 'vuex';
/* components */
import MediaLink from '@/components/MediaLink';
/* tools */
import {} from '@/scripts/utils';
import { mediaLinks } from '@/scripts/constants/map';
import { getAsset } from '@/scripts/utils';

export default {
  name: 'ComingSoon',
  components: {
    MediaLink,
  },
  props: {
    show: {
      type: Boolean,
      default: !false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.mediaLinks = mediaLinks;
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    getAsset,
  },
};
</script>

<template>
  <div
    class="root"
    v-if="show"
    :style="getAsset('bg-game', { type: 'png', path: 'home', style: true })"
  >
    <div class="container">
      <div class="coming">
        <div class="coming__logo">
          <img :src="require('@/assets/svg/logo-footer.svg')" />
        </div>
        <div class="coming__subtitle">Killer Rewards</div>
        <div class="coming__text">
          Get rewarded for every kill you make in your favorite games
        </div>
        <div class="coming__title">Coming Soon</div>
      </div>
      <div class="bottom">
        <div class="text">
          Subscribe and stay up to date with the latest news!
        </div>
        <div class="social">
          <!-- map -->
          <div v-for="item in mediaLinks" :key="item.id" class="social__item">
            <MediaLink :item="item" class="media-link--lg"></MediaLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.root {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 0 106px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1165px;
  background-color: #0e0e0e;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(14, 14, 14, 0.3);
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

.coming {
  width: 100%;
  max-width: 786px;
  min-height: 346px;
  border: solid 1px rgba(255, 193, 7, 0.4);
  border-bottom: 0;
  border-radius: 24px;
  text-align: center;
  padding: 40px 10px 40px;
  flex-shrink: 0;
  position: relative;

  &__subtitle {
    font-family: Sen-Bold;
    font-size: 36px;
    line-height: 43px;
    color: #ffd300;
    text-transform: uppercase;
  }

  &__text {
    font-family: Sen-Regular;
    font-size: 16px;
    line-height: 1.69;
    color: #ffffff;
    margin-top: 20px;
  }

  &__logo {
    display: flex;
    justify-content: center;
    height: 62px;
    width: 100%;
    padding: 0 10px;
    margin-bottom: 40px;

    img {
      display: flex;
      height: 100%;
      width: 100%;
      max-width: 615px;
    }
  }

  &__title {
    font-family: Sen-Bold;
    font-size: 60px;
    line-height: 72px;
    color: #ffc800;
    text-transform: uppercase;
    position: absolute;
    left: 0;
    bottom: 0;
    transform: translateY(50%);
    width: 100%;

    &:before {
      content: '';
      width: 100px;
      height: 100%;
      position: absolute;
      top: -50%;
      left: 0;
      border-bottom: solid 1px rgba(255, 193, 7, 0.4);
      border-bottom-left-radius: 24px;
    }

    &:after {
      content: '';
      width: 100px;
      height: 100%;
      position: absolute;
      top: -50%;
      right: 0;
      border-bottom: solid 1px rgba(255, 193, 7, 0.4);
      border-bottom-right-radius: 24px;
    }
  }
}

.bottom {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
}

.text {
  font-family: Sen-Regular;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  text-align: center;
  margin: 30px 0 20px;
}

.social {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  &__item {
    margin-top: 10px;
    margin-right: 18px;

    &:last-child {
      margin-right: 0;
    }
  }
}

@media (max-width: $mobile) {
  .root {
    padding: 80px 0;
  }

  .container {
    padding: 0 15px;
  }

  .coming {
    min-height: 250px;

    &__title {
      font-size: 30px;
      line-height: 1.2;

      &:before,
      &:after {
        width: 50px;
      }
    }

    &__logo {
      height: 30px;
      margin-bottom: 30px;
    }

    &__subtitle {
      font-size: 24px;
      line-height: 1.5;
    }

    &__text {
      font-size: 14px;
      line-height: 1.5;
      margin-top: 10px;
    }
  }
}
</style>
